import React from 'react';
import { Divider, Button } from 'semantic-ui-react';
import { shape, bool, func } from 'prop-types';
import { CurrencyLabel } from 'Modules/Currency';
import styles from './FeeContent.less';

const FeeVideo = ({
  fee, isReadOnly, onNext, onBack,
}) => (
  <div>
    <div className={styles.item}>
      <strong>VIDEO CONSULTATION</strong>
    </div>
    <div>
      <div className={styles.item}>
        <div className={styles.label} style={{ fontSize: '1.3em' }}><strong>Total</strong></div>
        <div className={styles.value}><CurrencyLabel value={fee.totalPrice} /></div>
      </div>
      <Divider hidden />
    </div>
    {
      !isReadOnly
      && (
        <div className={styles.actions}>
          <Button
            primary
            content="Next"
            onClick={onNext}
          />
          <Button content="Back" onClick={onBack} />
        </div>
      )
    }
  </div>
);

FeeVideo.propTypes = {
  isReadOnly: bool,
  onBack: func.isRequired,
  onNext: func.isRequired,
  fee: shape({}).isRequired,
};

FeeVideo.defaultProps = {
  isReadOnly: false,
};

export default FeeVideo;
